const loginRoutes = [
  {
    path: '/',
    name: 'Login',
    component: () => import( '@/pages/index.vue'),
    meta: {keepAlive: true, name: '登录'},
  },
]

export default loginRoutes



// WEBPACK FOOTER //
// ./src/router/modules/login.js